import React from 'react'
import useSelector from 'hooks/use-selector'
import getCurrentIdProductSelect from 'modules/product/redux/selectors/get-current-id'
import useDispatch from 'hooks/use-dispatch'
import getCurrentIdVariantSelect from 'modules/variant/redux/selectors/get-current-id'
import logUserDataConversionEventAction from 'containers/QuickShopProductSidebar/LogUserDataConversionEvent/actions/log-user-data-conversion-event'
import isLoadedCartSelect from 'modules/cart/redux/selectors/is-loaded'

export default function QuickShopProductSidebarLogUserDataConversionEvent () {
  const dispatch = useDispatch()
  const productId = useSelector(getCurrentIdProductSelect)
  const variantId = useSelector(getCurrentIdVariantSelect)
  const isCartLoaded = useSelector(isLoadedCartSelect)

  React.useEffect(() => {
    if (isCartLoaded) {
      dispatch(
        logUserDataConversionEventAction()
      )
    }
  }, [
    productId,
    variantId,
    isCartLoaded
  ])

  return <></>
}
